<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import 'stylesheets/global';

::v-deep .ui.form {
  @include font-heading(1rem, 400);

  margin: auto;
  width: 65%;

  @include sp {
    width: 100%;
  }

  .field {
    margin-bottom: 1.5rem;
  }

  .required.field > label::after {
    color: $required;
    content: '*';
    margin: 5px 0 0 10px;
    vertical-align: middle;
  }

  .warning-text {
    background: #f1c40f;
    color: #fff;
    padding: 5px;
  }

  input:not([type]),
  input[type='date'],
  input[type='datetime-local'],
  input[type='email'],
  input[type='file'],
  input[type='number'],
  input[type='password'],
  input[type='search'],
  input[type='tel'],
  input[type='text'],
  input[type='time'],
  input[type='url'],
  input[type='visibility'],
  textarea {
    border: 1px solid $black;
    border-radius: 0;
    padding: 1rem 1rem;
    padding-left: 1rem;
    width: 100%;
    @include font-heading(1em, 400);

    @include sp {
      font-size: 16px;
      padding: 1rem 1rem;
    }

    &::placeholder {
      color: $placeholder;
      font-size: 14px;

      @include sp {
        font-size: 12px;
      }
    }

    &.warning {
      border-color: #f1c40f;
    }
  }

  input:focus,
  input:active,
  textarea:focus,
  textarea:active {
    border: 1px solid $gray;
  }

  .date-dropdown-select,
  .ui.selection.dropdown {
    background: #fff;
    border: 1px solid $black;
    border-radius: 0;
    box-shadow: none;
    color: $black;
    cursor: pointer;
    display: inline-block;
    line-height: 1em;
    min-height: 2.71428571em;
    min-width: 14em;
    outline: 0;
    padding: 1rem 1rem;
    transform: rotateZ(0);
    transition: box-shadow 0.1s ease, width 0.1s ease;
    white-space: normal;
    word-wrap: break-word;
    .dropdown.icon {
      top: 0.9rem;
    }

    .default.text {
      color: $placeholder;
      font-size: 14px;

      @include sp {
        font-size: 12px;
      }
    }
  }

  .date-dropdown-select {
    appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-position-x: 100%;
    background-position-y: 5px;
    background-repeat: no-repeat;
    width: initial;

    &::after {
      border: 6px solid transparent;
      border-color: #fff transparent transparent transparent;
      content: '';
      height: 0;
      position: absolute;
      right: 10px;
      top: 14px;
      width: 0;
    }
  }

  .ui.selection.active.dropdown .menu {
    border-color: $black;
  }

  .checkbox-group {
    align-items: center;
    border: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .item {
      align-items: center;
      display: flex;
      flex-direction: row;
      margin-bottom: 1rem;
      width: 50%;

      @include sp {
        width: 100%;
      }

      .item-text {
        color: $black;
        max-width: 85%;
      }

      /* &:nth-child(3),
      &:nth-child(4) {
        margin-bottom: 0;
      } */

      input {
        appearance: none;
        box-sizing: content-box;
        margin-right: 1rem;
        overflow: hidden;
        position: relative;

        @include sp {
          height: 30px;
          padding-left: 3px;
          width: 30px;
        }

        &::before {
          background: $white;
          border: 1px solid #d4d4d5;
          border-radius: 0.21428571rem;
          content: '';
          height: 17px;
          left: 0;
          top: 0;
          transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease,
            box-shadow 0.1s ease;
          width: 17px;

          @include sp {
            height: 20px;
            transform: translateZ(0);
            width: 20px;
          }
        }

        &:checked::before {
          border: 1px solid $blue-primary;
          transition: 0.5s border-color ease;
        }

        &::after {
          background-color: $blue-primary;
          border-radius: 100vh;
          box-sizing: content-box;
          content: '';
          display: block;
          height: 30px;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%) scale(0);
          transform-origin: 50% 50%;
          width: 30px;

          @include sp {
            height: 15px;
            left: 43%;
            top: 35%;
            width: 8px;
          }
        }

        &:focus {
          border: none;
          box-shadow: none;
          outline: 0;
        }

        &[type='checkbox'] {
          position: absolute;

          &::before {
            border-radius: 0;
          }

          &::after {
            background-color: transparent;
            border-radius: 0;
            box-shadow: 4px 4px 0 0 $blue-primary;
            height: 16px;
            transform: translate(-50%, -85%) scale(0) rotate(45deg);
            width: 9.6px;
          }

          &:checked::after {
            animation: toggleOnCheckbox 0.2s ease forwards;
          }

          &.filled {
            &::before {
              border-radius: 4px;
              transition: 0.2s border-color ease, 0.2s background-color ease;
            }

            &:checked:not(:disabled)::before {
              background-color: $blue-primary;
            }

            &:not(:disabled)::after {
              box-shadow: 4px 4px 0 0 white;
            }
          }
        }
      }

      /* stylelint-disable declaration-no-important */
      label::after {
        color: $blue-primary !important;
      }
      /* stylelint-enable declaration-no-important */

      @-webkit-keyframes toggleOnCheckbox {
        0% {
          opacity: 0;
          transform: translate(-50%, -85%) scale(0) rotate(45deg);
        }

        70% {
          opacity: 1;
          transform: translate(-50%, -85%) scale(0.9) rotate(45deg);
        }

        100% {
          transform: translate(-50%, -85%) scale(0.8) rotate(45deg);
        }
      }

      @keyframes toggleOnCheckbox {
        0% {
          opacity: 0;
          transform: translate(-50%, -85%) scale(0) rotate(45deg);
        }

        70% {
          opacity: 1;
          transform: translate(-50%, -85%) scale(0.9) rotate(45deg);
        }

        100% {
          transform: translate(-50%, -85%) scale(0.8) rotate(45deg);
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
